import { assetPath } from "../i18n/routes";

type BrandMarkProps = {
  size?: number;
};

const iconSrc = assetPath("images/Icon.png");

export function BrandMark({ size = 30 }: BrandMarkProps) {
  return (
    <img
      src={iconSrc}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      className="inline-block rounded-[9px] object-cover"
      style={{ width: size, height: size }}
    />
  );
}
